export var ErrorDescription;
(function (ErrorDescription) {
    ErrorDescription["PropertyNotFound"] = "XX not found in response";
    ErrorDescription["GetSurveyError"] = "Get survey error";
    ErrorDescription["LoginError"] = "Login error";
    ErrorDescription["LastAnswersError"] = "Last answers error";
    ErrorDescription["SubmitSurveyError"] = "Submit survey error";
    ErrorDescription["GetCountriesError"] = "Get countries error";
    ErrorDescription["GetOnboardingError"] = "Get onboarding error";
    ErrorDescription["PutOnboardingError"] = "Put onboarding error";
    ErrorDescription["SignDocumentError"] = "Not able to sign attorney of power document";
    ErrorDescription["UploadDocumentError"] = "Unable to upload file";
    ErrorDescription["ClearAnswersError"] = "Clear answers error";
    ErrorDescription["ClearCompanyAnswerError"] = "Clear company answer error";
    ErrorDescription["UpdateEmailError"] = "Unable to update email address";
    ErrorDescription["UpdateAddressError"] = "Unable to update address";
    ErrorDescription["GetFundsError"] = "Unable to get funds";
    ErrorDescription["GetBanksError"] = "Unable to get banks";
    ErrorDescription["PostPurchaseRequestError"] = "Unable to post purchase request";
    ErrorDescription["GetAppropriateFundsError"] = "Unable to get funds error";
    ErrorDescription["PostRelinquishRightsError"] = "Post relinquish rights error";
    ErrorDescription["PutCompanyAddressError"] = "Put company address error";
    ErrorDescription["GetRaiseError"] = "Get raise error";
    ErrorDescription["GetTimeoutErorr"] = "Get timeout error";
    ErrorDescription["GetCompaniesError"] = "Get companies error";
    ErrorDescription["GetCompaniesAnswerInfoError"] = "Get companies error";
    ErrorDescription["GetChildrenError"] = "Get children error";
    ErrorDescription["GetStringsError"] = "Get strings error";
    ErrorDescription["GetBankProductsError"] = "Get bank products error";
    ErrorDescription["GetGeneralBankingOnboardingError"] = "Get general banking onboarding error";
    ErrorDescription["PutGeneralBankingOnboardingError"] = "Put general banking onboarding error";
    ErrorDescription["PutGeneralBankinOnboardingPinError"] = "Put general banking onboarding pin error";
    ErrorDescription["GetCurrentAuthSessionError"] = "Get current auth session error";
    ErrorDescription["GetOnboardingBlockersError"] = "Get onboarding blockers error";
    ErrorDescription["PostExchangeTokenError"] = "Post exchange token error";
    ErrorDescription["GetPrivateBankingOnboardingError"] = "Get private banking onboarding error";
    ErrorDescription["PutPrivateBankingOnboardingError"] = "Put private banking onboarding error";
    ErrorDescription["PostOnboardingPinError"] = "Post onboarding pin error";
    ErrorDescription["PostUsersTerms"] = "Post users terms error";
    ErrorDescription["GetPortfoliosError"] = "Get portfolios url error";
    ErrorDescription["PostDebugPortfolioError"] = "Post debug portfolio error";
    ErrorDescription["PostDebugPortfoliosWithSSNError"] = "Post debug portfolios with ssn error";
    ErrorDescription["LogoutError"] = "Unable to logout";
    ErrorDescription["GetPortfolioTransactionsError"] = "Get portfolio transactinos error";
    ErrorDescription["GetUserDetailsError"] = "Get user details error";
    ErrorDescription["GetInvestmentUserError"] = "Get investment user error";
    ErrorDescription["PostSelectedInvestmentUserError"] = "Post selected investment user error";
    ErrorDescription["GetPortoliosForSelectedUserError"] = "Get portfolios for selected user error";
    ErrorDescription["GetInstrumentPriceHistoryError"] = "Get instrument price history error";
    ErrorDescription["GetPortfoliosPerformanceError"] = "Get portfolios perfermonce error";
    ErrorDescription["GetSelectedInvestmentUserError"] = "Get selected investment user error";
    ErrorDescription["PostStartLoginError"] = "Post start login error";
    ErrorDescription["GetLoginStatusError"] = "Get login status error";
    ErrorDescription["PostEmailError"] = "Post email error";
    ErrorDescription["GetForwardContractsSummaryError"] = "Get forward contracts summary error";
    ErrorDescription["GetDerivativesAccessError"] = "Get derivatives access error";
    ErrorDescription["GetForwardContractsError"] = "Get forward contracts error";
    ErrorDescription["GetInstrumentDetailError"] = "Get instrument detail error";
})(ErrorDescription || (ErrorDescription = {}));
//# sourceMappingURL=Constants.js.map